import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../redux-store";

export interface AsperaUploadCardData {
  uploadCardIndex: number;
  uploadCardStatus: "noFile" | "readyToUpload" | "uploadInProgress" | "uploadDone";
}

const initialState: AsperaUploadCardData[] = [];

export const asperaUploadSlice = createSlice({
  name: "asperaUpload",
  initialState,

  reducers: {
    CreateUploadCard: (state, action: PayloadAction<AsperaUploadCardData>) => {
      if (action.payload.uploadCardIndex < 0) return;

      state.push(action.payload);
    },

    UpdateUploadCardStatus: (state, action: PayloadAction<AsperaUploadCardData>) => {
      if (action.payload.uploadCardIndex < 0) return;

      const index = state.findIndex((x) => x.uploadCardIndex === action.payload.uploadCardIndex);
      if (index < 0) return;

      state[index].uploadCardStatus = action.payload.uploadCardStatus;
    },

    DeleteUploadCardData: (state, action: PayloadAction<number>) => {
      const indexToDelete = state.findIndex((x) => x.uploadCardIndex === action.payload);
      if (indexToDelete !== -1) state.splice(indexToDelete, 1);
    },
    DeleteAllUploadCardData: (state) => {
      state = [];
    },
  },
});

export const { CreateUploadCard, UpdateUploadCardStatus, DeleteUploadCardData, DeleteAllUploadCardData } =
  asperaUploadSlice.actions;

export const GetUploadCardReadyToUploadIndexes = createSelector(
  [(state: RootState) => state.asperaUpload],
  (uploadCards: AsperaUploadCardData[]) =>
    uploadCards.filter((x) => x.uploadCardStatus === "readyToUpload").flatMap((x) => x.uploadCardIndex)
);

export const GetUploadCardState = (state: RootState): AsperaUploadCardData[] => {
  return state.asperaUpload;
};

export const GetUploadCardStatus = (state: RootState, cardIndex: number) =>
  state.asperaUpload.find((x) => x.uploadCardIndex === cardIndex)?.uploadCardStatus || "noFile";

export default asperaUploadSlice.reducer;
